import * as React from "react";
import Modal from "@mui/material/Modal";
import {
  ButtonWrapper,
  ModalDescription,
  ModalHeader,
  ModalTitle,
  StyledBox,
} from "./style";
import CustomButton from "../../common/button/CustomButton";
import { useNavigate } from "react-router-dom";
import profile from "../../../assets/images/featured-icon-success.png";
import theme from "../../../theme";
import close from "../../../assets/images/x-close-black.png";
import { useSelector } from "react-redux";

export default function ProfileSuccess({ open, handleClose }) {
  const navigate = useNavigate();
  const profileDetails = useSelector((state) => state?.auth?.profileDetails);
  const isPersonalShopper = profileDetails.user_type === "personal_shopper";
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledBox>
        <ModalHeader>
          <img src={profile} alt="profile" loading="lazy" />
          <img
            src={close}
            alt="close"
            loading="lazy"
            height={38}
            onClick={() => handleClose()}
          />
        </ModalHeader>
        <ModalTitle>Profile Created Successfully!</ModalTitle>
        <ModalDescription>
          Thanks for sharing your details. Your Profile has been
          <br /> successfully set up!
        </ModalDescription>
        <ButtonWrapper>
          {isPersonalShopper ? (
            <CustomButton
              padding="10px 37px"
              btntype={"primary"}
              color={theme.palette.custom.white}
              btnLabel={"Done"}
              onClick={() => handleClose()}
            />
          ) : (
            <>
              <CustomButton
                padding="10px 64px"
                fontSize={theme.typography.regular.fontSize}
                height="44px"
                btnLabel="Later"
                btntype={"white"}
                color={theme.palette.custom.lockerValueColor}
                fontWeight={theme.typography.fontWeight.medium}
                border={theme.borders.defaultButton}
                onClick={() => handleClose()}
              />
              <CustomButton
                padding="10px 37px"
                btntype={"primary"}
                color={theme.palette.custom.white}
                btnLabel={"View Locker"}
                onClick={() => navigate("/dashboard/locker")}
              />
            </>
          )}
        </ButtonWrapper>
      </StyledBox>
    </Modal>
  );
}
